export const MixpanelEvents = {
  DASHBOARD: 'view_dashboard',
  POPUPS_REQUIRED: 'view_popups_required',
  CLIENTS: 'view_clients',
  CLIENT_DETAILS: 'view_client_details',
  CLIENT_DETAILS_PROFILE: 'view_client_details_profile',
  CLIENT_PROFILE_INFO: 'view_client_details_profile_info',
  CLIENT_PROFILE_BILLING: 'view_client_details_profile_billing',
  CLIENT_PROFILE_NOTES: 'view_client_details_profile_notes',
  CLIENT_PROFILE_CONTACTS: 'view_client_details_profile_contacts',
  MY_SHOP: 'view_my_shop',
  MY_SHOP_ADD_ITEM: 'view_my_shop_add_new_item',
  MY_SHOP_ADD_ITEM_DETAILS: 'view_my_shop_add_new_item_details',
  MY_SHOP_ADD_ITEM_PRICING: 'view_my_shop_add_new_item_pricing',
  MY_SHOP_FABRICATION: 'view_my_shop_fabrication',
  MY_SHOP_FABRICATION_DETAILS: 'view_my_shop_fabrication_details',
  MY_SHOP_FABRICATION_PRICING: 'view_my_shop_fabrication_pricing',
  MY_SHOP_FABRICATION_SETTINGS: 'view_my_shop_fabrication_construction_settings',
  MY_SHOP_FEES: 'view_my_shop_fees',
  MY_SHOP_FEES_DETAILS: 'view_my_shop_fees_details',
  MY_SHOP_FEES_PRICING: 'view_my_shop_fees_pricing',
  MY_SHOP_FABRICS: 'view_my_shop_fabrics',
  MY_SHOP_FABRICS_DETAILS: 'view_my_shop_fabrics_details',
  MY_SHOP_FABRICS_PRICING: 'view_my_shop_fabrics_pricing',
  MY_SHOP_FABRICS_SPECIFICATIONS: 'view_my_shop_fabrics_specifications',
  MY_SHOP_LININGS: 'view_my_shop_linings',
  MY_SHOP_LININGS_DETAILS: 'view_my_shop_linings_details',
  MY_SHOP_LININGS_PRICING: 'view_my_shop_linings_pricing',
  MY_SHOP_LININGS_SPECIFICATIONS: 'view_my_shop_linings_specifications',
  SUPPLIERS: 'view_suppliers',
  SUPPLIER_PROFILE: 'view_supplier_profile',
  SUPPLIER_PROFILE_INFO: 'view_supplier_profile_info',
  SUPPLIER_PROFILE_BILLING: 'view_supplier_profile_billing',
  SUPPLIER_PROFILE_CONTACTS: 'view_supplier_profile_contacts',
  SUPPLIER_PROFILE_NOTES: 'view_supplier_profile_notes',
  ITEM_ORDER: 'view_item_order',
  ITEM_ORDER_SETUP: 'view_item_order_setup',
  ITEM_ORDER_DESIGN: 'view_item_order_design',
  ITEM_ORDER_FABRICS: 'view_item_order_fabrics',
  ITEM_ORDER_HARDWARE: 'view_item_order_hardware',
  ITEM_ORDER_UPLOADS: 'view_item_order_uploads',
  ITEM_ORDER_SUMMARY: 'view_item_order_summary',
  USER_SETTINGS: 'view_user_settings',
  ACCOUNT_SETTINGS: 'view_account_settings',
  ACCOUNT_SETTINGS_ESTIMATES_SAVE: 'account-settings_estimates_save',
  ESTIMATE_SAVE: 'estimate_save',
  ESTIMATE_SAVE_AND_SEND: 'estimate_save-and-send',
  ESTIMATE_PREVIEW: 'estimate_preview',
  ESTIMATE_QB: 'estimate_qb',
  ESTIMATE_PDF: 'estimate_pdf',
  QB_EXPORT: 'qb_export',
  QB_CONNECT: 'qb_connect',
  QB_CLIENT_IMPORT: 'qb_client_import',
  DELETE_ORDER: 'order_delete',
  DUPLICATE_ORDER: 'order_duplicate',
  UPDATE_ORDER: 'order_update',
  SAVE_ORDER: 'order_save',
  CREATE_NEW_ORDER: 'order_new_create',
  SAVE_FABRICATION: 'save_my_shop_fabrication',
  SAVE_FABRIC: 'save_my_shop_fabric',
  SAVE_FEES: 'save_my_shop_fees',
  SAVE_FEE_PRICING: 'save_my_shop_fee_pricing',
  CHANGE_PROJECT_STATUS: 'change_project_status',
  CHANGE_ITEM_STATUS: 'change_item_status',
  SAVE_CUSTOM_STATUS: 'save_item_custom_status',
  UPLOAD_COMPANY_LOGO: 'upload_company_logo',
  CANCEL_EDIT_FABRICATION: 'cancel_my_shop_fabrication',
  FILE_UPLOAD: 'file_upload',
  SET_AS_DRAFT: 'set-as-draft',
  SAVE_FINAL: 'save-final',
  SAVE_DRAFT: 'save-draft',
  FABRIC_URL_SUBMIT: 'fabric-url-submit',
  FABRIC_SAVE: 'fabric-save',
  FABRIC_URL_DISMISS: 'fabric-url-dismiss',
};
